import axios from 'axios';

// Creating a separate axios instance WITHOUT interceptors for downloads
const downloadClient = axios.create({
    timeout: 60000, // 60 second timeout for large files
    responseType: 'blob',
    // DO NOT add authorization headers
});

// Download API functions
const downloadExcelFile = {
    // Get filename from the API with json=1 parameter
    // This function returns the filename without downloading the actual file
    getFileName: (downloadKey) => {
        const apiBaseUrl = process.env.REACT_APP_API_URL;

        // Build the full URL
        let fullUrl = downloadKey;
        if (!downloadKey.startsWith('http')) {
            fullUrl = `${apiBaseUrl}/download/${downloadKey}`;
        }

        // Remove trailing slash if present and add it back after domain
        fullUrl = fullUrl.replace(/\/$/, '');
        if (!fullUrl.endsWith('/')) {
            fullUrl += '/';
        }

        // console.log('Calling download API with URL:', fullUrl + '?json=1');

        // Create a separate client for JSON response
        const jsonClient = axios.create({
            timeout: 60000,
            responseType: 'json',
        });

        return jsonClient.get(`${fullUrl}?json=1`, {
            headers: {
                'Accept': 'application/json',
            },
            withCredentials: false,
        });
    },

    // Download file directly using the download key from the path
    // Calls the full URL without authorization or interceptors
    downloadFileByKey: (downloadKey) => {
        const apiBaseUrl = process.env.REACT_APP_API_URL;

        // Build the full URL
        // If downloadKey already contains full path, use it as is
        // Otherwise construct the URL
        let fullUrl = downloadKey;
        if (!downloadKey.startsWith('http')) {
            fullUrl = `${apiBaseUrl}/download/${downloadKey}`;
        }

        // Remove trailing slash if present and add it back after domain
        fullUrl = fullUrl.replace(/\/$/, '');
        if (!fullUrl.endsWith('/')) {
            fullUrl += '/';
        }

        // console.log('Calling download API with URL:', fullUrl);

        return downloadClient.get(fullUrl, {
            headers: {
                'Accept': '*/*', // Accept any response type
                // Don't send Authorization header
                // Don't send Content-Type header for GET requests
            },
            withCredentials: false, // Don't send cookies
        });
    },
};

export default downloadExcelFile;